import axios from 'axios'
import endpoints from '../../endpoints'
import {SecurityBase} from './type'
import {APIResponse, NFCBase, NFCCreate} from '../../../types/type'

const API_URL = process.env.REACT_APP_API_URL || ''

export async function fetchSecurityList(): Promise<APIResponse<SecurityBase[]>> {
  const response = await axios.get(API_URL + endpoints.security.list)
  return response.data
}

export async function createSecurity(
  body: Omit<SecurityBase, 'security_id'>
): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.security.create, body)
  return response.data
}

export async function updateSecurity(body: SecurityBase): Promise<APIResponse<null>> {
  const response = await axios.post(API_URL + endpoints.security.update, body)
  return response.data
}

export async function deleteSecurity(securityId: string | number): Promise<APIResponse<null>> {
  const response = await axios.get(API_URL + endpoints.security.delete + securityId)
  return response.data
}
export async function addNFCtoSecurity(payload: NFCCreate) {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.createUserNFC, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getSecurityNFC(id: number): Promise<APIResponse<NFCBase>> {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.getUserNFC, {
      id,
      type: 'security',
    })
    return response.data
  } catch (error) {
    throw error
  }
}
